import { useTranslation } from "react-i18next";
import { formatNumber } from "src/utility";
import { useJourneyStaticDetails, useJourneyDynamicDetails } from "../../context";
import useTotalFare from "../../hooks/useTotalFare";
import SkeletonBox from "src/components/SkeletonBox/SkeletonBox";

export default function TotalAmountStrip() {
  const { t } = useTranslation();
  const { journeyDetails } = useJourneyStaticDetails();
  const { payment } = useJourneyDynamicDetails();
  const { totalPrice, pointsFactor, isFetching } = useTotalFare();
  const currency = journeyDetails.data?.fare?.currency ?? "";
  const showSkeleton = isFetching || !payment.selectedPayment;

  return (
    <div className="flex items-center justify-between px-4 md:py-3 py-2">
      <span className="text-font-subtle uppercase text-xs font-semibold tracking-wide">{t("Flights.details.summary.totalAmount")}</span>
      {showSkeleton ? (
        <SkeletonBox className="h-5 w-32" />
      ) : (
        <div className="flex gap-2 items-center font-semibold text-sm">
          <span>{formatNumber(totalPrice)} {currency}</span>
          <span className="border border-dashed border-border-disabled rounded-full h-6 w-6 flex items-center justify-center text-xs leading-1 text-font-default">{t("Flights.details.summary.or")}</span>
          <span className="text-font-active font-bold">{formatNumber(Math.ceil(pointsFactor * totalPrice))} {t("Flights.details.summary.ptsShort")}</span>
        </div>
      )}
    </div>
  );
}
